import { toKurus } from "@/shared/utils/currency";

// Types
export type BaseFieldProps = {
    name: string;
    label?: string | React.ReactNode;
    description?: string;
    className?: string;
    labelType?: "text" | "tooltip";
    tooltipContent?: string;
};

export type Option = {
    label: string;
    value: string;
    disabled?: boolean;
    /**
     * Seçeneğin altına muted ikinci satır olarak basılır. Asıl kullanımı **seçilemez**
     * seçeneğin nedenidir: disabled item `pointer-events-none` taşıdığı için native `title`
     * tooltip'i hover'da hiç açılmaz — neden görünür kalsın diye satır olarak yazılır.
     */
    description?: string;
};

/**
 * Combobox için "seçim varken Delete/Backspace ile temizle" onKeyDown üreticisi.
 * Seçili bir değer varken tuş, seçimi tek adımda atomik olarak temizler (etiketten
 * karakter silmek yerine). Yalnız temizlemeyi destekleyen (clear'lı) combobox'larda kullan.
 */
export function comboboxClearKeyDown(
    hasValue: boolean,
    clear: () => void,
): (event: React.KeyboardEvent) => void {
    return (event) => {
        if ((event.key === "Backspace" || event.key === "Delete") && hasValue) {
            event.preventDefault();
            clear();
        }
    };
}

// Currency formatting utilities
export function formatCurrency(value: number | string, decimals: number = 2): string {
    if (value === "" || value === null || value === undefined) return "";

    let num: number;
    if (typeof value === "string") {
        if (value.includes(",")) {
            // Türk formatı (1.000,50): noktalar binlik ayracı, virgül ondalık
            num = parseFloat(value.replace(/\./g, "").replace(",", "."));
        } else {
            // Standart format (10.00): nokta ondalık ayracı (backend formatı)
            num = parseFloat(value);
        }
    } else {
        num = value;
    }
    if (isNaN(num)) return "";

    // Türk formatı: binlik ayracı nokta, ondalık virgül
    const parts = num.toFixed(decimals).split(".");
    const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    const decimalPart = parts[1];

    return `${integerPart},${decimalPart}`;
}

export function parseCurrencyToNumber(value: string): number {
    if (!value) return 0;
    // Türk formatından sayıya çevir: noktaları kaldır, virgülü noktaya çevir
    const cleanValue = value.replace(/\./g, "").replace(",", ".");
    return toKurus(cleanValue) / 100;
}
